<template>
	<div class="page-content"  style="position: relative;">
		<Breadcrumb :breadcrumbArray="breadcrumbArray"></Breadcrumb>
		<span class="download-list" @click="onTurnToDownloadList">下载任务列表</span>
		<ComplaintBox
			v-for="(item, index) in complaintData"
			:key="index"
			:platform="item.platform"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Breadcrumb from 'components/breadcrumb/breadcrumb';
import ComplaintBox from 'components/complaintBox/complaintBox';
export default {
	name: 'ComplaintReportDownload',

	components:{
		Breadcrumb,
		ComplaintBox,
	},

	data () {
		return {
			complaintData: [
				{
					platform: 'TB'
				},
				{
					platform: 'SN'
				},
				{
					platform: 'PDD'
				},
				{
					platform: 'JD'
				},
				{
					platform: 'DY'
				},
			],
			breadcrumbArray: ['智慧服务', '投诉报表下载']
		}
	},

	methods: {
		onTurnToDownloadList() {
			this.$router.push('/ComplaintDownloadList');
		},
		...mapActions([
      'reqPlateList',
    ]),
	},

	computed: {},

	created() {},

	mounted() {},
}
</script>


<style lang='scss'>
.download-list {
	position: absolute;
	right: 20px;
	color: #409eff;
	cursor: pointer;
}
@import "style/activityApproval.scss";
</style>
